module.exports = __webpack_public_path__ + "img/QOOKER_Box18.7af897fd.jpg";